<template>
  <a @click="toggleExpanded" @keydown="handleTabKey">
    <slot />
  </a>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
    }
  },
  props: {
    link: {
      type: String,
    },
    loop: {
      type: String,
    },
  },
  computed: {
    getLinkData: function() {
      // parses the JSON
      return JSON.parse(this.link)
    },
    getLoopData: function() {
      return JSON.parse(this.loop)
    },
  },
  methods: {
    toggleExpanded: function(event) {
      const link = this.getLinkData
      if (link.type == 'toggle') {
        event.preventDefault()
        this.expanded = !this.expanded
        eventBus.$emit('nav:link:' + link.id, this.expanded)
      }
    },
    updateExpanded: function(expanded) {
      this.expanded = expanded
    },
    setFocus: function() {
      this.$el.focus()
    },
    handleTabKey(event) {
      if (this.getLoopData.last && event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault()
        eventBus.$emit('select:trigger')
      }
    },
  },
  mounted() {
    if (this.getLoopData.first && !this.expanded) {
      eventBus.$on('select:menu:first', this.setFocus)
    } else if (this.getLoopData.last && !this.expanded) {
      eventBus.$on('select:menu:last', this.setFocus)
    }
    eventBus.$on('nav:parent:' + this.getLinkData.id, this.setFocus)
  },
}
</script>
